export default {
  personalData: 'Persoonlijke gegevens',
};
